import React, { ReactNode, useEffect, useState } from "react"
import {
	Grid,
	DialogContent,
	Button,
	Link
} from "@material-ui/core"
import {
	Add as PlusSignal
} from "@material-ui/icons"

import { ActionDialog, Loading } from "@/components"

import ManageCustomField from "@/pages/Admin/CustomFields/ManageCustomField"
import GroupListVariable from "@/pages/Admin/CustomFields/GroupListVariable"
import CustomFieldIntroduction from "@/pages/Admin/CustomFields/CustomFieldIntroduction"
import ManageCustomFieldGroup from "@/pages/Admin/CustomFields/ManageCustomFieldGroup"

import CustomFieldGroupPermissionGate from "@/components/PermissionGate/CustomFieldGroupPermissionGate"

import ApiService from "@/services/Api"
import ErrorHandlerService from "@/services/ErrorHandler"

import { CustomFieldGroupList } from "@/protocols/customField"

import { ErrorType } from "@/hooks/useValidation"

import CustomFieldGroupsSkeleton from "@/skeletons/Admin/CustomFieldSkeletons"

import { letalkLinks } from "@/utils/link"

import { renderComponent } from "@/utils/node"

import useStyles from "@/pages/Admin/CustomFields/styles"
import useCustomStyles from "@/styles/custom"

export type CustomFieldDialog = {
	children?: ReactNode
	initialOpen?: boolean
}

type CustomFieldsDialogType = React.FC<CustomFieldDialog> & {
	open: () => void
}

const CustomFieldsDialog: CustomFieldsDialogType = ({ children, initialOpen = false }) => {
	const [openCustomFieldPanel, setOpenCustomFieldPanel] = useState(initialOpen)
	const [loading, setLoading] = useState(false)
	const [customFieldGroupList, setCustomFiedlGroupList] = useState<CustomFieldGroupList[]>()

	const handleCustomFieldCloseDialog = () => {
		setOpenCustomFieldPanel(false)
	}

	const handleGetCustomFieldsGroupData = async () => {
		try {
			const { data } = await ApiService.get("/custom-fields/group")
			setCustomFiedlGroupList(data.customFieldsGroups)
		} catch (error) {
			ErrorHandlerService.handle(error as ErrorType)
		}
	}

	const onDataChange = async () => {
		await handleGetCustomFieldsGroupData()
		setLoading(false)
	}

	const handleCustomFieldOpenPanelDialog = () => {
		setLoading(true)
		onDataChange()
		setOpenCustomFieldPanel(true)
	}

	useEffect(() => {
		if (initialOpen) {
			onDataChange()
		}
	}, [])

	const customStyles = useStyles()
	const customClasses = useCustomStyles()
	return (
		<>
			<div
				onClick={handleCustomFieldOpenPanelDialog}
			>
				{children}
			</div>
			<ActionDialog
				onClose={handleCustomFieldCloseDialog}
				openDialog={openCustomFieldPanel}
				title={"PAINEL DE CAMPOS PERSONALIZADOS"}
				fullWidth
				maxWidth="lg"
				hideCloseButton={true}
			>
				<Link
					href={letalkLinks.wikiHowToCreateCustomField}
					underline="always"
					target="_blank"
					color="inherit"
				>
					Clique aqui e descubra como criar campos na sua plataforma
				</Link>

				<DialogContent style={{ height: 655, marginTop: 24 }}>
					<Grid container alignItems="center" spacing={2}>
						<Grid item>
							<CustomFieldGroupPermissionGate action="create">
								<ManageCustomField onDataChange={onDataChange} customFieldGroupList={customFieldGroupList} onUpdateCustomFieldGroupList={handleGetCustomFieldsGroupData}>
									<Button variant="contained" className={customClasses.buttonAction} startIcon={<PlusSignal />}>ADICIONAR CAMPO PERSONALIZADO</Button>
								</ManageCustomField>
							</CustomFieldGroupPermissionGate>
						</Grid>
						<Grid item>
							<ManageCustomFieldGroup onDataChange={onDataChange}>
								<Button className={customStyles.buttonAction} startIcon={<PlusSignal />}>ADICIONAR UM NOVO GRUPO</Button>
							</ManageCustomFieldGroup>
						</Grid>
					</Grid>
					<Loading loading={loading} customLoadingElement={<CustomFieldGroupsSkeleton />}>
						{!loading && <Grid container direction="column" justifyContent="center">
							{customFieldGroupList && customFieldGroupList.length > 0 ? <GroupListVariable groupList={customFieldGroupList} onDataChange={onDataChange} /> : <CustomFieldIntroduction />}
						</Grid>}
					</Loading>

				</DialogContent>
			</ActionDialog>
		</>
	)
}

CustomFieldsDialog.open = () => {
	renderComponent(
		"custom-fields-dialog",
		<CustomFieldsDialog initialOpen={true} />
	)
}

export default CustomFieldsDialog
